@if (loadError) {
  <section class="link-status">
    <div class="status-card">
      <i class="fas fa-triangle-exclamation status-icon"></i>
      <h3>We couldn't open this link</h3>
      <p>Please check your connection and try again. If the problem continues, contact your account manager.</p>
    </div>
  </section>
} @else if (!loading && report) {
  @switch (report.status) {
    @case (STATUS.VALID) {
      <section class="link-status">
        <div class="status-card report-card">
          <i class="fas fa-file-lines status-icon status-icon-ok"></i>
          <h3>Your report</h3>
          @if (report.subject) {
            <p class="subject">{{ report.subject }}</p>
          }
          <ul class="document-list">
            @for (document of report.documents; track document.emailDocumentId) {
              <li class="document-row">
                <div class="document-name">
                  <i class="fas fa-file-pdf"></i>
                  <span>{{ document.fileName }}</span>
                  <small>{{ fileSize(document.sizeBytes) }}</small>
                </div>
                <div class="document-actions">
                  @if (canView(document)) {
                    <a class="action action-primary" [href]="viewUrl(document)" target="_blank" rel="noopener">View</a>
                  }
                  <a class="action" [href]="downloadUrl(document)" rel="noopener">Download</a>
                </div>
              </li>
            }
          </ul>
          @if (report.expiresDateTime) {
            <p class="note">This link expires on {{ report.expiresDateTime | date: 'MMMM d, y' }}. Please download the report and keep a copy for your records.</p>
          }
        </div>
      </section>
    }
    @case (STATUS.EXPIRED) {
      <section class="link-status">
        <div class="status-card">
          <i class="fas fa-clock status-icon"></i>
          <h3>This link has expired</h3>
          @if (report.expiresDateTime) {
            <p>It expired on {{ report.expiresDateTime | date: 'MMMM d, y' }}.</p>
          }
          <p>If you need this report, please contact your MMI team.</p>
          <p class="staff-note">MMI staff: <a [routerLink]="staffLink()">open this report in MMISafeV2</a>.</p>
        </div>
      </section>
    }
    @case (STATUS.UNAVAILABLE) {
      <section class="link-status">
        <div class="status-card">
          <i class="fas fa-link-slash status-icon"></i>
          <h3>This link is no longer available</h3>
          <p>If you need this report, please contact your MMI team.</p>
          <p class="staff-note">MMI staff: <a [routerLink]="staffLink()">open this report in MMISafeV2</a>.</p>
        </div>
      </section>
    }
    @default {
      <section class="link-status">
        <div class="status-card">
          <i class="fas fa-link-slash status-icon"></i>
          <h3>This link is not valid</h3>
          <p>Please check that the whole link was copied. If you need this report, please contact your MMI team.</p>
        </div>
      </section>
    }
  }
}
